import { CbConfig } from "./cb.config"

export const config = new CbConfig()
